var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", [_c("a-form-model", {
    attrs: {
      model: _vm.form
    }
  }, [_c("a-form-model-item", {
    attrs: {
      label: _vm.$t("选择样式")
    }
  }, [_c("div", {
    staticClass: "imgList"
  }, _vm._l(_vm.configureList, function (item, index) {
    return _c("div", {
      key: index,
      class: _vm.form.controlsComponentsMark == item.mark ? "hit" : "",
      on: {
        click: function ($event) {
          return _vm.imgClick(item.mark, item.id);
        }
      }
    }, [_c("img", {
      attrs: {
        src: item.icon
      }
    })]);
  }), 0)]), _c("a-form-model-item", {
    staticStyle: {
      display: "flex"
    },
    attrs: {
      label: _vm.$t("是否展示logo")
    }
  }, [_c("div", [_c("a-radio-group", {
    on: {
      change: _vm.logoChangeFun
    },
    model: {
      value: _vm.form.controlsLogoDisplay,
      callback: function ($$v) {
        _vm.$set(_vm.form, "controlsLogoDisplay", $$v);
      },
      expression: "form.controlsLogoDisplay"
    }
  }, [_c("a-radio", {
    attrs: {
      value: true
    }
  }, [_vm._v(" " + _vm._s(_vm.$t(`是`)) + " ")]), _c("a-radio", {
    attrs: {
      value: false
    }
  }, [_vm._v(" " + _vm._s(_vm.$t(`否`)) + " ")])], 1)], 1)]), _vm.form.controlsLogoDisplay ? _c("a-form-model-item", {
    staticStyle: {
      display: "flex"
    },
    attrs: {
      label: _vm.$t("logo展示")
    }
  }, [_c("a-radio-group", {
    model: {
      value: _vm.form.controlsLogoExhibitor,
      callback: function ($$v) {
        _vm.$set(_vm.form, "controlsLogoExhibitor", $$v);
      },
      expression: "form.controlsLogoExhibitor"
    }
  }, [_c("a-radio", {
    attrs: {
      value: 1
    }
  }, [_vm._v(" " + _vm._s(_vm.$t(`承保单位`)) + " ")]), _c("a-radio", {
    attrs: {
      value: 2
    }
  }, [_vm._v(" " + _vm._s(_vm.$t(`中介机构`)) + " ")])], 1)], 1) : _vm._e(), _vm.form.controlsComponentsMark == "mainDrawing7" || _vm.form.controlsComponentsMark == "mainDrawing6" ? _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("其他提示配置")
    }
  }, [_c("div", {
    staticClass: "selectedItem"
  }, [_c("div", {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.$t("本产品由xxx公司")))]), _c("div", {
    staticClass: "contBox"
  }, [_c("a-input", {
    staticStyle: {
      width: "150px"
    },
    attrs: {
      placeholder: _vm.$t("请输入后缀信息"),
      maxLength: 20
    },
    on: {
      blur: _vm.handleBlurTrim
    },
    model: {
      value: _vm.form.thirdCompanySuffix,
      callback: function ($$v) {
        _vm.$set(_vm.form, "thirdCompanySuffix", $$v);
      },
      expression: "form.thirdCompanySuffix"
    }
  })], 1)])]) : _vm._e(), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("产品名称设置")
    }
  }, [_c("div", {
    staticClass: "selectedItem"
  }, [_c("div", {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.$t("字体颜色")))]), _c("div", {
    staticClass: "contBox"
  }, [_c("div", {
    staticClass: "colorBox",
    style: "background:" + _vm.form.productNameColor
  }), _c("a-button", {
    staticClass: "size",
    attrs: {
      type: "link"
    },
    on: {
      click: function ($event) {
        return _vm.colorClickFun(_vm.form.productNameColor, "productNameColor");
      }
    }
  }, [_vm._v("[" + _vm._s(_vm.$t("更换")) + "]")])], 1)]), _c("div", {
    staticClass: "selectedItem"
  }, [_c("div", {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.$t("字体增大")))]), _c("div", {
    staticClass: "contBox"
  }, [_c("a-select", {
    staticStyle: {
      width: "100px"
    },
    on: {
      change: _vm.changeFun
    },
    model: {
      value: _vm.form.productNameFontSize,
      callback: function ($$v) {
        _vm.$set(_vm.form, "productNameFontSize", $$v);
      },
      expression: "form.productNameFontSize"
    }
  }, [_c("a-select-option", {
    attrs: {
      value: 14
    }
  }, [_vm._v(" 14px ")]), _c("a-select-option", {
    attrs: {
      value: 16
    }
  }, [_vm._v(" 16px ")]), _c("a-select-option", {
    attrs: {
      value: 18
    }
  }, [_vm._v(" 18px ")])], 1)], 1)])]), _c("a-form-model-item", {
    attrs: {
      label: _vm.$t("其他字段设置")
    }
  }, [_c("div", {
    staticClass: "selectedItem"
  }, [_c("div", {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.$t("字体颜色")))]), _c("div", {
    staticClass: "contBox"
  }, [_c("div", {
    staticClass: "colorBox",
    style: "background:" + _vm.form.otherFieldsColor
  }), _c("a-button", {
    staticClass: "size",
    attrs: {
      type: "link"
    },
    on: {
      click: function ($event) {
        return _vm.colorClickFun(_vm.form.otherFieldsColor, "otherFieldsColor");
      }
    }
  }, [_vm._v("[" + _vm._s(_vm.$t("更换")) + "]")])], 1)]), _c("div", {
    staticClass: "selectedItem"
  }, [_c("div", {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.$t("字体增大")))]), _c("div", {
    staticClass: "contBox"
  }, [_c("a-select", {
    staticStyle: {
      width: "100px"
    },
    on: {
      change: _vm.changeFun
    },
    model: {
      value: _vm.form.otherFieldsFontSize,
      callback: function ($$v) {
        _vm.$set(_vm.form, "otherFieldsFontSize", $$v);
      },
      expression: "form.otherFieldsFontSize"
    }
  }, [_c("a-select-option", {
    attrs: {
      value: 12
    }
  }, [_vm._v(" 12px ")]), _c("a-select-option", {
    attrs: {
      value: 14
    }
  }, [_vm._v(" 14px ")]), _c("a-select-option", {
    attrs: {
      value: 16
    }
  }, [_vm._v(" 16px ")])], 1)], 1)])])], 1), _vm.colorShow ? _c("color-model", {
    ref: "colorRef",
    on: {
      cancel: function ($event) {
        _vm.colorShow = false;
      },
      ok: _vm.colorFun
    }
  }) : _vm._e()], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };